package org.ssoft.common.ui.wheel

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.font.FontFamily
import apps.App

object AppWheelFactory {

    fun createResultGenerator(
        loadSvg: suspend (id: Long) -> Painter?,
        loadWebp: suspend (id: Long) -> ImageBitmap?,
        display: Pair<Int, Int> = 1920 to 1080
    ): WheelResultGenerator = InternalWheelResultGenerator(loadSvg, loadWebp, display)

    fun createWheelGenerator(
        loadSvg: suspend (id: Long) -> Painter?,
        loadWebp: suspend (id: Long) -> ImageBitmap?,
        display: Pair<Int, Int> = 1920 to 1080
    ): WheelCircleGenerator = InternalWheelCircleGenerator(loadSvg, loadWebp, display)

    interface WheelResultGenerator {
        suspend fun generate(
            fontResolver: FontFamily.Resolver,
            item: App.Wheel.Item,
            code: String,
            isLand: Boolean
        ): ImageBitmap
    }

    interface WheelCircleGenerator {

        companion object;

        suspend fun generate(
            fontResolver: FontFamily.Resolver,
            config: App.Wheel.Content,
        ): ImageBitmap

        suspend fun launchCollector(
            fontResolver: FontFamily.Resolver,
            onNewBitmap: (ImageBitmap) -> Unit
        )

        fun postTask(config: App.Wheel.Content)
    }

    @Composable
    fun StartupScreen(
        config: App.Wheel,
        bgImage: ImageBitmap?,
        qr: Painter,
        modifier: Modifier,
    ) {
        WheelStartupScreen(
            config = config,
            bgImage = bgImage,
            qr = qr,
            modifier = modifier,
        )
    }

    fun buildTrianglePath(
        wheelScale: Float,
        wheelX: Float,
        wheelY: Float,
        screen: Size
    ): Path {
        val wheelSize = ((wheelScale) * minOf(
            screen.width,
            screen.height
        ))

        val topPosition = Offset(
            (screen.width * wheelX),
            (screen.height * wheelY) - (wheelSize / 2F)
        )
        val triangleSizeH = Size(wheelSize / 15F, wheelSize / 8F) / 2F

        return Path().apply {
            moveTo(
                x = topPosition.x - triangleSizeH.width,
                y = topPosition.y - (triangleSizeH.height * 0.7F)
            )
            lineTo(
                x = topPosition.x + triangleSizeH.width,
                y = topPosition.y - (triangleSizeH.height * 0.7F)
            )
            lineTo(
                x = topPosition.x,
                y = topPosition.y + (triangleSizeH.height * 0.3F)
            )
            close()
        }
    }

    @Composable
    fun StartupScreen(
        modifier: Modifier,
        bgColor: Color,
        bgImage: ImageBitmap?,
        showQr: Boolean,
        qrX: Float,
        qrY: Float,
        qrScale: Float,
        qrPadding: Float,
        qr: Painter
    ) {
        WheelStartupScreen(
            modifier = modifier,
            bgColor = bgColor,
            bgImage = bgImage,
            showQr = showQr,
            qrX = qrX,
            qrY = qrY,
            qrScale = qrScale,
            qrPadding = qrPadding,
            qr = qr
        )
    }
}